import { render, staticRenderFns } from "./ItemsSection.vue?vue&type=template&id=77394190"
import script from "./ItemsSection.vue?vue&type=script&lang=js"
export * from "./ItemsSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports